import React from "react";
import PhonesInput from "react-phone-number-input/input";
import styles from "./phoneInput.module.css";
const PhoneInput = (props) => {
  return (
    <div className={styles.phoneLabel} style={props?.style}>
      <label
      >
        {props?.label}
      </label>
      <div className={styles.phoneInput}>
        <PhonesInput
          style={{
            outline: "none",
            border: 0,
            width: "100%",
          }}
          placeholder={"+1 (234) 456-4567"}
          className={styles.PhoneNumber}
          defaultCountry="US"
          value={props?.value}
          maxLength={16}
          onChange={props?.onChange}
        />
      </div>
    </div>
  );
};

export default PhoneInput;
